import { inject, Injectable } from '@angular/core';

import { FavoritesService } from './favorites.service';

const ID_LIST_LOTTERY_FAVORITES = 'idListLoteryFavorites';

@Injectable({
  providedIn: 'root',
})
export class LotteryFavoritesService {
  favoritesService = inject(FavoritesService);

  constructor() {
    const stored = localStorage.getItem(ID_LIST_LOTTERY_FAVORITES);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          this.favoritesService.idsLotteryFavorites.set(parsed);
        }
      } catch (e) {
        console.error('Error parsing localStorage favorites:', e);
        // En caso de error, podrías limpiar el valor o dejarlo vacío
        this.favoritesService.idsLotteryFavorites.set([]);
      }
    }
  }

  setLotteryFavorites(id: string) {
    this.favoritesService.idsLotteryFavorites.update((prev) => [...prev, id]);
    localStorage.setItem(
      ID_LIST_LOTTERY_FAVORITES,
      JSON.stringify(this.favoritesService.idsLotteryFavorites())
    );
  }

  deleteLotteryFavorites(id: string) {
    this.favoritesService.idsLotteryFavorites.update((prev) =>
      prev.filter((lotteryId) => lotteryId !== id)
    );
    localStorage.setItem(
      ID_LIST_LOTTERY_FAVORITES,
      JSON.stringify(this.favoritesService.idsLotteryFavorites())
    );
  }

  isFavoriteLottery(id: string) {
    return this.favoritesService.idsLotteryFavorites().includes(id);
  }
}
